<template>
  <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogShow"
      width="800px"
      @open="handleOpen"
      @close="handleClose"
      :append-to-body="appended">
    <div style="margin-top: 30px">
      <el-row>
        <el-col :span="6">
          <el-input v-model="keyword"
                    placeholder="输入品名/商家编码"
                    @keyup.native.enter="searchSkuByKeyword()"
                    class="input-item-short"
                    clearable
          ></el-input>
        </el-col>
<!--        <el-col :span="7" v-if="vipSelectable">-->
<!--          <vips :teamid="teamid" @teamChange="teamChange"></vips>-->
<!--        </el-col>-->
        <el-col :span="3">
          <el-select v-model="viewable" style="margin-left: 12px;">
            <el-option :value="null" label="全部"></el-option>
            <el-option :value="true" label="上架"></el-option>
            <el-option :value="false" label="下架"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="searchSkuByKeyword()" style="margin-top: 0; margin-left: 12px;">搜索</el-button>
        </el-col>
        <el-col :span="8">
          <el-button type="warning" @click="confirmSelections" style="margin-top: 0px" v-if="multi">选择</el-button>
        </el-col>
      </el-row>
      <el-row style="margin-top: 8px; margin-bottom: 12px;">
        <el-col :span="6">
          <el-input v-model="resultFilterText" placeholder="结果中搜索" @clear="doFilter" @keyup.native.enter="doFilter" clearable>
            <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-tabs v-model="activeTab" type="card">
        <el-tab-pane label="商品名/商家编码搜索" name="first">
          <el-row>
            <el-table
                v-loading="skuListLoading"
                :data="skuList.filter(item => !item.hidden)"
                border
                height="450px"
                style="width: 100%"
                ref="multipleTable1"
                @selection-change="onStockSelectionsChange"
            >
              <el-table-column type="selection" align="center" v-if="multi">
              </el-table-column>
              <el-table-column label="商品图片" align="center">
                <template slot-scope="props">
                  <el-image
                      class="img_box_mini"
                      :src="props.row.image"
                      :preview-src-list="[props.row.image]"
                  ></el-image>
                </template>
              </el-table-column>
              <el-table-column label="商品名称" prop="productName" align="center">
              </el-table-column>
              <el-table-column label="商家编码" prop="code" align="center">
              </el-table-column>
              <el-table-column label="规格" prop="specs" align="center">
              </el-table-column>
              <el-table-column label="状态" prop="viewable" align="center">
                <template slot-scope="{ row }">
                  <el-tag :type="row.viewable ? 'success' : 'info'" effect="plain" size="medium">
                    {{ row.viewable ? '上架' : '下架'}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="替代商家编码" prop="substituteCode" align="center">
              </el-table-column>
              <el-table-column label="选择" align="center">
                <template slot-scope="{row}">
                  <el-button type="success" size="mini" @click="confirmSku(row)">{{confirmBtn}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row>
            <el-pagination
                @current-change="handleDialogCurrentChange"
                :current-page.sync="pageInfo.page"
                :page-size="pageInfo.size"
                layout="total, prev, pager, next"
                :total="pageInfo.total">
            </el-pagination>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div style="height: 10px">
      </div>
    </div>
  </el-dialog>
</template>

<script>
import platformUtils from "~/utils/platformUtils";
import erpProductApi from "~/request/newSys/erpProductApi";

export default {
  props: {
    teamid: {
      type: Number
    },
    visible: {
      type: Boolean
    },
    title: {
      type: String
    },
    confirmBtnText: {
      type: String
    },
    multi: {
      type: Boolean,
      default: false
    },
    appended: {
      type: Boolean,
      default: false
    },
    vipSelectable: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      activeTab: 'first',
      dialogTitle: this.title || '',
      keyword: '',
      skuListLoading: false,
      skuList: [],
      pageInfo: {
        page: 0,
        size: 20,
        total: 0
      },

      confirmBtn: this.confirmBtnText || '选择',

      selections1: [],

      selections: [],

      PLATFORMS: [],
      platformSelected: null,

      searchTeam: null,
      resultFilterText: '',
      viewable: true
    }
  },

  methods: {
    searchSkuByKeyword(page) {
      let keyword = this.keyword || ''
      keyword = keyword.trim()
      if (!keyword) {
        this.$message.warning('请输入关键词进行搜索～')
        return
      }
      if (keyword && keyword.length < 2) {
        this.$message({
          message: '关键字过短',
          type: 'warning'
        })
        return
      }
      keyword = encodeURIComponent(keyword)
      this.searchTeam = this.teamid
      this.skuListLoading = true
      this.skuList = []
      page = page || 0
      const teamId = this.searchTeam
      let viewable = this.viewable
      if (viewable !== null) {
        viewable = viewable ? 'true' : 'false'
      }
      erpProductApi.searchSkuByKeyword(teamId, keyword, viewable, page).then(data => {
        this.skuList = data.data
        this.skuListLoading = false
        this.pageInfo.page = data.page
        this.pageInfo.total = data.total
        this.doFilter()
      }).catch(err => {
        this.$message.error(err.message)
        console.log('searchSkuByKeyword err', err)
      })

    },

    doFilter() {
      const filterText = this.resultFilterText || ''
      const skuList = this.skuList
      this.doFilterForList(skuList, filterText)
    },

    doFilterForList(list, text) {
      if (list && list.length) {
        list.forEach(item => {
          let fullText = ''
          fullText += (item.productName || '')
          fullText += (item.snCode || '')
          fullText += (item.specs || '')
          this.$set(item, 'hidden', fullText.indexOf(text) <= -1)
        })
      }
    },

    teamChange(val) {
      this.$emit('teamChange', val)
    },

    confirmSelections() {
      const selections = this.selections1
      const copies = JSON.parse(JSON.stringify(selections))
      this.$refs.multipleTable1.clearSelection()
      this.$emit('confirmMultipleSelections', copies)
    },

    onStockSelectionsChange(selection) {
      this.selections1 = selection
    },

    handleOpen() {
      //初始化
      this.keyword = ''
      this.resultFilterText = ''
      this.pageInfo = {
        page: 0,
        size: 20,
        total: 0
      }
      this.viewable = true
      this.skuList = []
    },

    handleClose() {
      this.$emit('dialogClose')
    },

    confirmSku(row) {
      const teamId = this.searchTeam
      this.$emit('confirmSelection', row, teamId)
    },

    handleDialogCurrentChange(val) {
      this.searchSkuByKeyword(val - 1)
    },

  },

  mounted() {
    this.PLATFORMS = platformUtils.getOptions(false, true, true)
  },

  computed: {
    dialogShow: {
      get() {
        return this.visible
      },
      set(v) {

      }
    }
  }
}
</script>

<style scoped>

.cell {
  font-size: 12px;
  text-align: center;
  padding: 0;
}

.el-table td,
.el-table th {
  padding: 4px 0;
}

.table_box {
  margin-top: 12px;
}

.el-table .cell,
.el-table th div {
  padding-left: 0px;
  padding-right: 0px;
}

.img_box_mini {
  width: 50px;
  height: 55px;
}

.input-item-short {
  width: 200px;
  height: 44px;
}

</style>



// WEBPACK FOOTER //
// src/components/NewSkuSelection/index.vue